import { Link } from "react-router-dom";

const OurBelief = () => {
  return (
    <section className="py-20 bg-secondary">
      <div className="container mx-auto px-6 max-w-3xl text-center">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-foreground mb-8">
          Our Belief
        </h2>
        <p className="text-lg text-foreground/80 font-sans leading-relaxed mb-6">
          As women of color we learned how to mix handfuls of love with scoops of confidence 
          until we wore beauty like we invented it — because we did. We were gifted with the 
          ability to make curls from scratch. All we had was all we ever needed.
        </p>
        <p className="text-lg text-foreground/80 font-sans leading-relaxed">
          We don't have to straighten out for nobody. Our entire existence is kinky, curly, 
          nappy — a two and three-strand twist of beauty, resilience, ingenuity and innovation, 
          with a future full of promise as big as our fro.
        </p>
        <div className="mt-10">
          <Link
            to="/our-story"
            className="inline-block border-2 border-primary text-primary px-8 py-3 rounded-sm font-sans font-semibold text-sm uppercase tracking-widest hover:bg-primary hover:text-primary-foreground transition-colors"
          >
            Read Our Story
          </Link>
        </div>
      </div>
    </section>
  );
};

export default OurBelief;
